/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TestExternalTranscoderConnectionRequest
 */
export interface TestExternalTranscoderConnectionRequest {
    /**
     * 
     * @type {string}
     * @memberof TestExternalTranscoderConnectionRequest
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof TestExternalTranscoderConnectionRequest
     */
    address: string;
}

export function TestExternalTranscoderConnectionRequestFromJSON(json: any): TestExternalTranscoderConnectionRequest {
    return TestExternalTranscoderConnectionRequestFromJSONTyped(json, false);
}

export function TestExternalTranscoderConnectionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestExternalTranscoderConnectionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'address': json['address'],
    };
}

export function TestExternalTranscoderConnectionRequestToJSON(value?: TestExternalTranscoderConnectionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'address': value.address,
    };
}


